// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConfirmDate_confirmDate__SxC5f {
  width: auto;
}
.ConfirmDate_confirmDate__calendarWrapper__xD744 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ConfirmDate_confirmDate__timeInput__5Nuhb {
  margin-top: 1rem;
  max-width: 360px;
  width: 100%;
}
.ConfirmDate_confirmDate__actions__yc7fi {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
}
.ConfirmDate_confirmDate__button__e-feC {
  background: linear-gradient(to right, #3D7EBE, #495867);
  color: #ffffff;
  border: none;
  padding: 0.6rem 2rem;
  font-size: 0.9rem;
  font-weight: 400;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  text-transform: none;
}
.ConfirmDate_confirmDate__button__e-feC:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(61, 126, 190, 0.3);
}
@media (max-width: 767px) {
  .ConfirmDate_confirmDate__SxC5f {
    margin-top: 4rem;
  }
  .ConfirmDate_confirmDate__button__e-feC {
    width: 46%;
    padding: 0.8rem;
    font-size: 0.7rem;
  }
  .ConfirmDate_confirmDate__button__e-feC svg {
    font-size: 1.1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BookingPage/Step/ConfirmDate/ConfirmDate.module.scss"],"names":[],"mappings":"AAIA;EACE,WAAA;AAHF;AAKE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAHJ;AAME;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;AAJJ;AAOE;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AALJ;AAQE;EACE,uDAAA;EACA,cA1BU;EA2BV,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,2CAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;AANJ;AAQI;EACE,2BAAA;EACA,8CAAA;AANN;AAcE;EA9CF;IA+CI,gBAAA;EAXF;EAYE;IACE,UAAA;IACA,eAAA;IACA,iBAAA;EAVJ;EAWI;IACE,iBAAA;EATN;AACF","sourcesContent":["$primary-color: #3D7EBE;\n$white-color: #ffffff;\n$breakpoint-md: 767px; \n\n.confirmDate {\n  width: auto;\n\n  &__calendarWrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  &__timeInput {\n    margin-top: 1rem;\n    max-width: 360px;\n    width: 100%;\n  }\n\n  &__actions {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 2rem;\n  }\n\n  &__button {\n    background: linear-gradient(to right, $primary-color, #495867);\n    color: $white-color;\n    border: none;\n    padding: 0.6rem 2rem;\n    font-size: 0.9rem;\n    font-weight: 400;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: transform 0.2s, box-shadow 0.2s;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    text-transform: none;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 4px 15px rgba($primary-color, 0.3);\n    }\n\n    // &--back {\n    //   // Estilos específicos para el botón \"Atrás\" si los hubiera\n    // }\n  }\n\n  @media (max-width: $breakpoint-md) {\n    margin-top: 4rem;\n    &__button {\n      width: 46%;\n      padding: 0.8rem;\n      font-size: 0.7rem;\n      svg{\n        font-size: 1.1rem;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmDate": `ConfirmDate_confirmDate__SxC5f`,
	"confirmDate__calendarWrapper": `ConfirmDate_confirmDate__calendarWrapper__xD744`,
	"confirmDate__timeInput": `ConfirmDate_confirmDate__timeInput__5Nuhb`,
	"confirmDate__actions": `ConfirmDate_confirmDate__actions__yc7fi`,
	"confirmDate__button": `ConfirmDate_confirmDate__button__e-feC`
};
export default ___CSS_LOADER_EXPORT___;
